import { useState, useEffect } from 'react';
import axios from 'axios';
import { useNavigate } from 'react-router-dom';
import Notification from '../shared/Notification';
import NavHeader from './NavHeader';
import styles from './forget-password.module.css';

const ForgetPassword = () => {
    const [error, setError] = useState('');
    const [notification, setNotification] = useState('');
    const [loading, setLoading] = useState(false);
    const [formData, setFormData] = useState({ emailOrPhone: '' });
    const navigate = useNavigate();

    useEffect(() => {
        const message = localStorage.getItem('notification');
        if (message) { setNotification(message); localStorage.removeItem('notification'); }
    }, []);

    const handleChange = (e) => setFormData({ ...formData, [e.target.name]: e.target.value });

    const handleSubmit = async (e) => {
        e.preventDefault();
        setLoading(true);
        setError('Sending reset code...');
        try {
            const response = await axios.post('/api/authApplicant/forget-password', formData);
            setError(response.data.message);
            sessionStorage.setItem('verifyEmailOrPhone', formData.emailOrPhone);
            navigate('/reset-password');
        } catch (error) {
            const msg = error.response?.data?.message || 'An error occurred. Please try again.';
            setNotification(msg);
            setError(msg);
        } finally {
            setLoading(false);
        }
    };

    return (
        <>
        <NavHeader />
        {notification && <Notification message={notification} onClose={() => setNotification('')} />}

        <div className={styles.forgetPage}>
            <div className={styles.card}>

                <div className={styles.cardHeader}>
                    <h1 className={styles.headline}>Forgot password? 🔐</h1>
                    <p className={styles.subtext}>We'll send a reset code to your email.</p>
                </div>

                <div className={styles.cardBody}>
                    <form onSubmit={handleSubmit} className={styles.forgetPasswordForm}>

                        <div className={styles.fieldWrap}>
                            <span className={styles.fieldIcon}>✉</span>
                            <input
                                className={styles.input}
                                type="text"
                                name="emailOrPhone"
                                placeholder="Registered Email"
                                value={formData.emailOrPhone}
                                onChange={handleChange}
                                required
                            />
                        </div>

                        {error && <div className={styles.errorMsg}>{error}</div>}

                        <button type="submit" className={styles.submitBtn} disabled={loading}>
                            {loading ? 'Sending…' : 'Send reset code →'}
                        </button>

                        <div className={styles.links}>
                            <p>Forgot your email? <a href="/contact-us">Contact us</a></p>
                            <p><a href="/login">← Back to login</a></p>
                        </div>

                    </form>
                </div>

            </div>
        </div>
        </>
    );
};

export default ForgetPassword;